import { Component, Input, Output, EventEmitter } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatBadgeModule } from "@angular/material/badge";
import { Availability, BundleProductDto } from "../bundle.interfaces";

@Component({
  selector: "lib-bundle-product-list-item",
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatBadgeModule],
  templateUrl: "./bundle-product-list-item.component.html",
  styleUrl: "./bundle-product-list-item.component.scss",
})
export class BundleProductListItemComponent {
  @Input() product: BundleProductDto;
  @Input() selectedProducts: BundleProductDto[];
  @Output() increment = new EventEmitter<BundleProductDto>();
  @Output() decrement = new EventEmitter<BundleProductDto>();
  private _bundleSize: number;
  Availability = Availability;
  @Input()
  set bundleSize(size: number) {
    this._bundleSize = size;
  }

  get bundleSize(): number {
    return this._bundleSize;
  }

  get quantity(): number {
    let quantity = 0;
    this.selectedProducts.forEach((p) => {
      if (p.productId === this.product.productId) {
        quantity += p.quantity ?? 0;
      }
    });
    return quantity;
  }

  get isSelected(): boolean {
    // Check if the current product exists in the selected products list based on productId
    return this.selectedProducts.some(
      (p) => p.productId === this.product.productId,
    );
  }

  incrementQuantity() {
    this.increment.emit(this.product);
  }

  decrementQuantity() {
    if (this.quantity > 0) {
      this.decrement.emit(this.product);
    }
  }
  isIncrementDisabled(): boolean {
    let totalQuantity = 0;
    for (const product of this.selectedProducts) {
      totalQuantity += product.quantity || 0;
    }

    return totalQuantity >= this.bundleSize;
  }

  isDecrementDisabled(): boolean {
    return this.quantity <= 0;
  }
}
